import PropertyWishlistContainer from "../../components/property/Wishlist";

const PropertyWishlist = () => {
  return <PropertyWishlistContainer />;
};

export default PropertyWishlist;
